import PropTypes from 'prop-types';
import Container from '@/components/Container';
import Link from '@/components/Link';
import Image from '@/components/Image';
import TrainingListingCard from '@/domain/Training/TrainingListingCard';
import client from '@/api/client';
import { trainingListingQuery } from '@/api/queries';

export async function getStaticProps() {
  const { data } = await client().query({ query: trainingListingQuery });

  return {
    props: {
      trainings: data?.trainings?.nodes || [],
    },
  };
}

const defaultProps = {
  trainings: [],
};

const propTypes = {
  trainings: PropTypes.arrayOf(PropTypes.object),
};

export default function TrainingListing({ trainings }) {
  return (
    <div>
      <div className="relative z-10 bg-white shadow-sm">
        <Container>
          <div className="relative -mb-px flex items-center space-x-4 lg:space-x-6">
            <span className="flex items-center border-b-2 border-green-500 py-4 px-1 font-medium text-green-500">
              Entrenamientos
            </span>
            <Link
              className="flex items-center border-b-2 border-transparent py-4 px-1 font-medium text-gray-500 hover:text-gray-900"
              href="/certificaciones"
            >
              Certificaciones
            </Link>
          </div>
        </Container>
      </div>
      <div className="space-y-10 bg-gray-100 py-10">
        <Container>
          <div
            className="rounded-lg bg-gray-900 px-4 py-3 text-lg text-gray-100 shadow-lg"
            role="alert"
          >
            <div className="flex items-start space-x-3 md:items-center">
              <div className="mt-1 md:mt-0">
                <svg
                  className="h-5 w-5 text-gray-400"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="flex-1 font-medium">
                <span className="inline-block">
                  Todos nuestros entrenamientos incluyen la certificación y la
                  insignia digital que se emite gracias a&nbsp;&nbsp;
                </span>
                <a
                  title="Asociación Iberoamericana de Scrum AIBES en Credly"
                  className="inline-block"
                  href="https://www.credly.com/organizations/asociacion-iberoamericana-de-scrum"
                >
                  <Image
                    alt="Credly"
                    className="inline-block"
                    src="credly.webp"
                    width={50}
                  />
                </a>
              </div>
            </div>
          </div>
        </Container>
        <Container>
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
            {trainings.map(({ id, ...training }) => (
              <div
                key={`training-listing-${id}`}
                className="flex lg:col-span-6"
              >
                <TrainingListingCard {...training} />
              </div>
            ))}
          </div>
        </Container>
      </div>
    </div>
  );
}

TrainingListing.defaultProps = defaultProps;
TrainingListing.propTypes = propTypes;
